/**
 * Centralized LiveKit media quality settings for web camera and screen share.
 */
import { ScreenSharePresets } from 'livekit-client';
import { AudioPresets } from 'livekit-client';
import type {
  ScreenShareCaptureOptions,
  TrackPublishDefaults,
  VideoCaptureOptions,
  VideoEncoding,
  VideoResolution,
} from 'livekit-client';

const CAMERA_WIDTH = 1920;
const CAMERA_HEIGHT = 1080;
const CAMERA_FRAME_RATE = 30;
const SCREEN_SHARE_FRAME_RATE = 30;
const SCREEN_SHARE_WIDTH = 1920;
const SCREEN_SHARE_HEIGHT = 1080;

export const WEB_CAMERA_RESOLUTION: VideoResolution = {
  width: CAMERA_WIDTH,
  height: CAMERA_HEIGHT,
  frameRate: CAMERA_FRAME_RATE,
  aspectRatio: CAMERA_WIDTH / CAMERA_HEIGHT,
};

export const WEB_CAMERA_CAPTURE_OPTIONS: VideoCaptureOptions = {
  resolution: WEB_CAMERA_RESOLUTION,
};

export const WEB_CAMERA_ENCODING: VideoEncoding = {
  maxBitrate: 6_000_000,
  maxFramerate: CAMERA_FRAME_RATE,
};

export const SCREEN_SHARE_RESOLUTION: VideoResolution = {
  width: SCREEN_SHARE_WIDTH,
  height: SCREEN_SHARE_HEIGHT,
  frameRate: SCREEN_SHARE_FRAME_RATE,
  aspectRatio: SCREEN_SHARE_WIDTH / SCREEN_SHARE_HEIGHT,
};

export const SCREEN_SHARE_CAPTURE_OPTIONS: ScreenShareCaptureOptions = {
  video: true,
  audio: false,
  resolution: SCREEN_SHARE_RESOLUTION,
};

export const SCREEN_SHARE_ENCODING: VideoEncoding = ScreenSharePresets.h1080fps30.encoding;

export const LIVEKIT_PUBLISH_DEFAULTS: TrackPublishDefaults = {
  audioPreset: AudioPresets.speech,
  dtx: true,
  red: true,
  videoEncoding: WEB_CAMERA_ENCODING,
  screenShareEncoding: SCREEN_SHARE_ENCODING,
};
